import {
  type AvatarSize,
  DynamicAvatarsStack,
  type DynamicAvatarsStackAlign
} from '@morpho-org/ui-v6/client'
import { formatters } from '@morpho-org/ui-v6/utils'

import type { TrustedByCurator } from '../../utils/createMarketTrustedByCurators'

import { MarketCuratorHoverCard } from '../MarketCuratorHoverCard'

export interface MarketTrustedByCuratorStackProps {
  trustedByCurators: TrustedByCurator[]
  className?: string
  avatarSize?: AvatarSize
  maxTokensCount?: number
  align?: DynamicAvatarsStackAlign
  /** Forwarded to the stack; only the hero row has a measured gap. */
  trailingSpace?: number
}

const MarketTrustedByCuratorStack = ({
  className,
  trustedByCurators,
  avatarSize = 'regular',
  maxTokensCount = 5,
  align = 'left',
  trailingSpace
}: MarketTrustedByCuratorStackProps) => {
  const dynamicAvatarStackItems = trustedByCurators.map(curator => {
    const vaults = curator.vaults.map(vault => {
      const formattedTotalAllocated = formatters.short
        .digits(2)
        .trailingZero(false)
        .unit('$')
        .default('-')
        .of(vault.totalAssetsUsd, 18)

      return {
        id: vault.id,
        address: vault.address,
        vaultName: vault.name,
        imageURI: vault.imageURI,
        chainId: vault.chainId,
        vaultDeposit: formattedTotalAllocated,
        isVaultV2: vault.isVaultV2
      }
    })

    return {
      hoverCardContent: (
        <MarketCuratorHoverCard
          curatorName={curator.name}
          curatorLogoURI={curator.logoURI}
          vaults={vaults}
        />
      ),
      logoUrl: curator.logoURI
    }
  })

  return (
    <DynamicAvatarsStack
      className={className}
      items={dynamicAvatarStackItems}
      maxTokensCount={maxTokensCount}
      avatarSize={avatarSize}
      isMobileSupportEnabled
      align={align}
      trailingSpace={trailingSpace}
    />
  )
}

export default MarketTrustedByCuratorStack
